import {
  AbstractStringStore,
  RegisteredKey,
  RegisteredKeyList,
} from './AbstractStringStore';

export class LocalStorageStore extends AbstractStringStore {
  constructor() {
    super('portal-items');
  }

  #serializeItemKey(rk: RegisteredKey) {
    return `${rk.context}:${rk.key}`;
  }

  protected clearImpl(list: RegisteredKeyList): void {
    for (const rk of list) {
      localStorage.removeItem(this.#serializeItemKey(rk));
    }
  }

  protected removeImpl(key: string, context: string): void {
    localStorage.removeItem(this.#serializeItemKey({ key, context }));
  }

  protected retrieveImpl(key: string, context: string): string | undefined {
    return (
      localStorage.getItem(this.#serializeItemKey({ key, context })) ??
      undefined
    );
  }

  protected storeImpl(key: string, value: string, context: string): void {
    localStorage.setItem(this.#serializeItemKey({ key, context }), value);
  }
}
